export const PROCESS_EXTERNAL_FLOW_UPDATE = "PROCESS_EXTERNAL_FLOW_UPDATE";
